import { Switch } from '@headlessui/react';
import cn from 'classnames';
import { forwardRef } from 'react';

type TInput = JSX.IntrinsicElements['input'];

export interface Radio
  extends Pick<
    TInput,
    'checked' | 'children' | 'className' | 'disabled' | 'name'
  > {
  onChange?: (checked: boolean) => void;
  size?: 16 | 20;
}

export const Radio = forwardRef<HTMLButtonElement, Radio>(
  ({ checked, children, className, disabled, onChange, size = 20 }, ref) => (
    <div
      className={cn(
        'flex w-fit items-center',
        {
          'cursor-not-allowed': disabled,
          'cursor-pointer': !disabled,
        },
        className,
      )}
      onClick={() => {
        if (!disabled) {
          onChange?.(!checked);
        }
      }}
      role="presentation"
    >
      <Switch
        ref={ref}
        className={cn(
          'relative flex items-center justify-center rounded-full border p-1 outline-none transition-colors duration-200',
          {
            'border-gray-400 bg-transparent': !disabled,
            'cursor-not-allowed border-gray-300 bg-gray-300': disabled,
            'border-blue-500': checked && !disabled,
            'h-4 w-4': size === 16,
            'h-5 w-5': size === 20,
          },
        )}
      >
        <div
          className={cn('h-full w-full rounded-full', {
            '[&>svg]:text-gray-500': disabled,
            'bg-blue-500 [&>svg]:text-white': checked && !disabled,
            'hover:bg-gray-100 group-hover:bg-gray-100': !checked && !disabled,
            hidden: !checked,
          })}
        />
      </Switch>
      {Boolean(children) && (
        <div
          className={cn('ms-2 text-14/100%', {
            'text-gray-500': disabled,
            'text-gray-800': !disabled,
          })}
        >
          {children}
        </div>
      )}
    </div>
  ),
);
